<template>
  <router-view/>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  created() {
    const getTopLevelDomain = () => {
      const hostnameParts = window.location.hostname.split('.');
      const topLevelDomain = hostnameParts[hostnameParts.length - 1];
      return topLevelDomain;
    };

    // getTopLevelDomain() === 'localhost' ||
    if (getTopLevelDomain() === 'org') (window as any).$lang = 'English';
  }
}
</script>
